<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :lg="6" :md="6" :span="6">
            <el-date-picker v-model="time" style="width: 97%" align="center" type="daterange" size="medium"
              :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期"></el-date-picker>
          </el-col>

          <el-col :lg="5" :md="5" :span="5">
            <el-select placeholder="渠道" clearable size="medium" v-model="searchChannelSelect"
              @change="searchChannelSelectChange" @focus="getChannel" style="width: 90%;">
              <el-option v-for="channel in searchChannels" :value="channel.channelId" :key="channel.channelId"
                :label="channel.channelName" />
            </el-select>
          </el-col>

          <el-col :lg="3" :md="3" :span="3">
            <el-select placeholder="类型" clearable size="medium" v-model="categorySelect" @change="categorySelectChange"
              style="width: 90%;">
              <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-col>

          <el-col :lg="6" :md="6" :span="6">
            <el-select placeholder="标题" clearable size="medium" v-model="extenId" @change="searchExtenIdChange"
              style="width: 90%;">
              <el-option v-for="item in dataList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>

          <el-col :lg="2" :md="2" :span="2">
            <el-button size="medium" type="primary" @click="getPushTaskData">搜索</el-button>
          </el-col>
        </el-row>
      </div>

      <el-table :data="tableData" border style="width: 100%;margin-top:30px;">
        <el-table-column label="序号" align="center" width="70">
          <template slot-scope="scope"><span>{{ scope.$index + (currentPage - 1) * pageSize + 1 }} </span></template>
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center" min-width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">文章</span>
            <span v-else-if="scope.row.type == 1">海报</span>
            <!-- <span v-else-if="scope.row.type == 2">活动</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" align="center"></el-table-column>
        <el-table-column prop="channelNames" label="渠道" align="center"></el-table-column>
        <el-table-column prop="createTime" label="生成时间" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center" min-width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">未开始</span>
            <span v-else-if="scope.row.status == 1">进行中</span>
            <span v-else-if="scope.row.status == 2">已结束</span>
            <span v-else-if="scope.row.status == 3">已禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == 1 && checkButtonPermission('push:manage:done')"
              @click="changeOperationButtonType(scope.$index, scope.row)"
              :type="scope.row.isPush === 0 ? 'success' : 'info'" size="mini">推送</el-button>
          </template>
          <!-- <el-button type="success" size="small" >推送</el-button> -->
        </el-table-column>
      </el-table>
      <div style="margin: 18px 0px; float: right;">
        <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
          :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "newPushList",
  data() {
    return {
      time: [
        new Date("2020/01/01 00:00:00"),
        new Date(new Date().setHours(23, 59, 59, 59))
      ],
      createTime: [],
      styleSelect: "",
      titleSelect: "",
      channelSelect: "",
      currentPage: 1,
      pageSize: 10,
      totalPage: 100,
      total: 156,
      searchChannels: [],
      searchChannelSelect: "",
      searchChannelSelectVal: "",
      categorySelect: "",
      dataList: [],
      extenId: "",
      categoryOptions: [
        { label: "文章", value: 0 },
        { label: "海报", value: 1 },
        // { label: "活动", value: 2 }
      ],
      tableData: []
    };
  },
  created() {
    this.getPushTaskData();
  },
  methods: {
    getPushTaskData() {
      let reqParam = {
        size: this.pageSize,
        currentPage: this.currentPage,
        channelId: this.searchChannelSelect,
        startTime: this.formatDate(this.time[0], "yyyy-MM-dd hh:mm:ss"),
        endTime: this.formatDate(this.time[1], "yyyy-MM-dd hh:mm:ss"),
        category: this.categorySelect,
        extenId: this.extenId,
        channelName: this.channelName
      };
      this.$http.post("/api/front/push/task/list", reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if ("success" == data.code) {
          let pageInfo = data.pageInfo;
          this.tableData = pageInfo.list;
          this.total = pageInfo.total;
          this.totalPage = pageInfo.pages;
        } else {
          this.$alert("" + data.message, "温馨提示", {
            confirmButtonText: "确定"
          });
        }
      })
        .catch(response => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + response,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.getPushTaskData();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.getPushTaskData();
    },
    styleSelectChange(val) {
      this.styleSelect = val;
    },
    titleSelectChange(val) {
      this.titleSelect = val;
    },
    channelSelectChange(val) {
      this.channelSelect = val;
    },
    changeOperationButtonType(index, row) {
      if (row.status === 1) {
        let info = "是否确认推送模板消息给相应渠道的推手?";
        if (row.isPush === 1) info = "已推送过，是否再次推送模板消息给相应渠道的推手?";

        this.$confirm(info, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info"
        })
          .then(() => {
            this.$http.post("/api/front/push/task", row, {
              headers: {
                accessToken: sessionStorage.getItem('accessToken')
              }
            }).then(resp => {
              let data = resp.data;
              if ("0" === data.code || 0 === data.code) {
                this.$message({
                  type: "success",
                  message: "推送成功"
                });
                this.getPushTaskData();
              } else {
                this.$alert("" + data.message, "温馨提示", {
                  confirmButtonText: "确定"
                });
              }
            })
              .catch(response => {
                this.$alert(
                  "服务器发生异常，请联系开发者，这是错误信息：" + response,
                  "错误提示",
                  {
                    confirmButtonText: "确定"
                  }
                );
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消推送"
            });
          });
      } else {
        this.$alert("未进行中不可推送", "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      }
    },
    getChannel() {
      this.$http
        .post("/api/channel-service/channel/logged/all", {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        })
        .then(resp => {
          let data = resp.data;
          if (data.code === "success") {
            this.searchChannels = data.resultList;
          }
        })
        .catch(e => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + e,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    },

    searchChannelSelectChange(val) {
      this.searchChannelSelectVal = val;
      let obj = this.searchChannels.find(item => {
        return item.channelId === val; //筛选出匹配数据
      });
      if (obj != undefined && obj) this.channelName = obj.channelName;
      else this.channelName = "";
    },
    categorySelectChange(val) {
      this.categorySelectVal = val;
      this.extenId = "";
      let obj = this.categoryOptions.find(item => {
        return item.value === val; //筛选出匹配数据
      });
      if (obj != undefined && obj) this.categoryName = obj.label;
      else this.categoryName = "";
      if (val === 0) {
        this.getArticles();
      } else if (val === 1) {
        this.getPosters();
      } else if (val === 2) {
        this.getActivitys();
      } else {
        this.dataList = [];
      }
    },
    getPosters() {
      this.$http
        .post("/api/popularize/poster/search", { size: 1000 })
        .then(resp => {
          let data = resp.data;
          if ("success" === data.code) {
            let pageInfo = data.pageInfo;
            let datas = pageInfo.list;
            this.dataList = [];
            for (let i = 0; i < datas.length; i++) {
              this.dataList.push({
                value: datas[i].posterId,
                label: datas[i].title
              });
            }
          } else {
            this.$alert("" + data.message, "温馨提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(response => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + response,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    },
    getArticles() {
      this.$http
        .post("/api/popularize/article/search", { size: 1000 })
        .then(resp => {
          let data = resp.data;
          if ("success" === data.code) {
            let pageInfo = data.pageInfo;
            let datas = pageInfo.list;
            this.dataList = [];
            for (let i = 0; i < datas.length; i++) {
              this.dataList.push({
                value: datas[i].articleId,
                label: datas[i].title
              });
            }
          } else {
            this.$alert("" + data.message, "温馨提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(response => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + response,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    },
    getActivitys() {
      this.$http
        .post("/api/front/activity/search", { currentPage: 1, size: 1000 })
        .then(resp => {
          let data = resp.data;
          if ("success" === data.code) {
            let pageInfo = data.pageInfo;
            let datas = pageInfo.list;
            this.dataList = [];
            for (let i = 0; i < datas.length; i++) {
              this.dataList.push({
                value: datas[i].activityId,
                label: datas[i].activityName
              });
            }
          } else {
            this.$alert("" + data.message, "温馨提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(response => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + response,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    },
    searchExtenIdChange(val) {
      let obj = this.dataList.find(item => {
        return item.value === val; //筛选出匹配数据
      });
      if (obj != undefined && obj) this.extenTitle = obj.label;
      else this.extenTitle = "";
    },
    formatDate(time, fmt) {
      let o = {
        "M+": time.getMonth() + 1, //月份
        "d+": time.getDate(), //日
        "h+": time.getHours(), //小时
        "m+": time.getMinutes(), //分
        "s+": time.getSeconds(), //秒
        "q+": Math.floor((time.getMonth() + 3) / 3), //季度
        S: time.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (time.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/push/newPushList/newPushList.vue